import {
  NonIdealState,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api } from "../../api";
import { AppStore } from "../../stores/AppStore";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
} from "mdbreact";
import { toast } from "react-toastify";
import { formatCnpj } from "../../utils";
import { PerfilStore } from "../../stores/perfil/PerfilStore";

interface AssinaturaContratoPageProps {
}

interface AssinaturaContratoPageState {
}

@observer
export class AssinaturaContratoPage extends React.Component<AssinaturaContratoPageProps, AssinaturaContratoPageState> {

  obs = observable({
    token: "" as string,
    dados_validos: false as boolean
  })
  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Contrato FIPO");
    await AppStore.loadUsuario()

    let userPrincipal = AppStore.obs1.usuario ? AppStore.obs1.usuario.principal : false;

    if (
      AppStore.obs1.dados_contrato.nome_pessoa != "" && AppStore.obs1.dados_contrato.nome_pessoa != null &&
      AppStore.obs1.dados_contrato.cpf_pessoa != "" && AppStore.obs1.dados_contrato.cpf_pessoa != null &&
      AppStore.obs1.dados_contrato.rua_pessoa != "" && AppStore.obs1.dados_contrato.rua_pessoa != null &&
      AppStore.obs1.dados_contrato.numero_pessoa != "" && AppStore.obs1.dados_contrato.numero_pessoa != null &&
      AppStore.obs1.dados_contrato.bairro_pessoa != "" && AppStore.obs1.dados_contrato.bairro_pessoa != null &&
      AppStore.obs1.dados_contrato.cidade_pessoa != "" && AppStore.obs1.dados_contrato.cidade_pessoa != null &&
      AppStore.obs1.dados_contrato.cep_pessoa != "" && AppStore.obs1.dados_contrato.cep_pessoa != null &&
      AppStore.obs1.dados_contrato.estado_pessoa != "" && AppStore.obs1.dados_contrato.estado_pessoa != null &&
      userPrincipal) {

      this.handleGerarContrato();
      this.obs.dados_validos = true;

    } else {
      this.obs.dados_validos = false;
    }
  }

  async handleGerarContrato() {
    try {
      let data = {
        razaoSocial: AppStore.obs1.dados_contrato.nome,
        cnpj: formatCnpj(AppStore.obs1.dados_contrato.cnpj),
        endereco: AppStore.obs1.dados_contrato.rua + ", NUMERO " + AppStore.obs1.dados_contrato.numero,
        bairro: AppStore.obs1.dados_contrato.bairro,
        cidade: AppStore.obs1.dados_contrato.cidade,
        cep: AppStore.obs1.dados_contrato.cep,
        nome: AppStore.obs1.dados_contrato.nome_pessoa,
        estado: AppStore.obs1.dados_contrato.estado,
        cpf_pessoa: AppStore.obs1.dados_contrato.cpf_pessoa,
        endereco_pessoa: AppStore.obs1.dados_contrato.rua_pessoa + ", Número " + AppStore.obs1.dados_contrato.numero_pessoa,
        bairro_pessoa: AppStore.obs1.dados_contrato.bairro_pessoa,
        cidade_pessoa: AppStore.obs1.dados_contrato.cidade_pessoa,
        cep_pessoa: AppStore.obs1.dados_contrato.cep_pessoa,
        estado_pessoa: AppStore.obs1.dados_contrato.estado_pessoa
      }

      let resp = await api.post("/api/create-contrato", data);

      if (resp.data.ok) {
        this.obs.token = resp.data.documento_key;
      } else {
        toast.error('Não foi possível gerar o contrato, tente novamente mais tarde ou entre em contato com o suporte.', {});
        return
      }
    } catch (ex) {
      toast.error('Erro ao gerar o contrato, tente novamente mais tarde.', {});
    }
  }

  handleRedireciona() {
    AppStore.setLocation("/perfil")
    PerfilStore.obs.contaEdit = true
    PerfilStore.obs.change_tab_conta = "contratante"
  }

  renderContrato() {
    return (
      <div className="dashboard-page">
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <iframe
                src={`https://app.zapsign.com.br/verificar/${this.obs.token}`}
                width="100%"
                height="800px"
              >
              </iframe>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }

  renderBlock() {
    const description = (
      <div className="NonIdeal">
        {"Verifique se seus dados estão preenchidos corretamente"}
        <br />
        <a style={{ color: "#3579ea" }} onClick={() => this.handleRedireciona()}>{"Perfil -> Editar Dados da Conta -> Contratante"}</a>
        <br />
      </div>
    );

    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          description={description}
        />
      </div>
    );
  }

  render() {
    if (this.obs.dados_validos) {
      return this.renderContrato();
    } else {
      return this.renderBlock();
    }
  }
}

export default AssinaturaContratoPage;
